import KanbanStagesAPI from '../../../api/kanbanStages';
import {
  SET_KANBAN_STAGES_UI_FLAG,
  SET_KANBAN_STAGES,
  ADD_KANBAN_STAGE,
  EDIT_KANBAN_STAGE,
  DELETE_KANBAN_STAGE,
} from './types';

export const actions = {
  get: async ({ commit }) => {
    commit(SET_KANBAN_STAGES_UI_FLAG, { isFetching: true });
    try {
      const { data } = await KanbanStagesAPI.get();
      commit(SET_KANBAN_STAGES, data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_KANBAN_STAGES_UI_FLAG, { isFetching: false });
    }
  },

  create: async ({ commit }, stageInfo) => {
    commit(SET_KANBAN_STAGES_UI_FLAG, { isCreating: true });
    try {
      const { data } = await KanbanStagesAPI.create({ kanban_stage: stageInfo });
      commit(ADD_KANBAN_STAGE, data);
      return data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_KANBAN_STAGES_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...stageInfo }) => {
    commit(SET_KANBAN_STAGES_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await KanbanStagesAPI.update(id, { kanban_stage: stageInfo });
      commit(EDIT_KANBAN_STAGE, data);
      return data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_KANBAN_STAGES_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit(SET_KANBAN_STAGES_UI_FLAG, { isDeleting: true });
    try {
      await KanbanStagesAPI.delete(id);
      commit(DELETE_KANBAN_STAGE, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_KANBAN_STAGES_UI_FLAG, { isDeleting: false });
    }
  },

  reorder: async ({ commit, state }, ids) => {
    const previous = { ...state.records };
    // optimistic local reorder
    const reordered = ids.map((id, idx) => ({ ...previous[id], position: idx }));
    commit(SET_KANBAN_STAGES, reordered);
    try {
      const { data } = await KanbanStagesAPI.reorder(ids);
      commit(SET_KANBAN_STAGES, data);
    } catch (error) {
      commit(SET_KANBAN_STAGES, Object.values(previous));
      throw new Error(error);
    }
  },
};
